import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_14549",
		"data-name": "Group 14549",
		transform: "translate(-1402 -151.899)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_11788",
			"data-name": "Group 11788",
			transform: "translate(1402 151.899)",
			children: /* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_573",
				"data-name": "Ellipse 573",
				cx: 30,
				cy: 30,
				r: 30,
				fill: "#fff",
				opacity: .856
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_12078",
			"data-name": "Group 12078",
			transform: "translate(1416 165.899)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group_2515",
				"data-name": "Group 2515",
				transform: "translate(0.663 0.663)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_728",
						"data-name": "Rectangle 728",
						width: 14.589,
						height: 18.568,
						transform: "translate(0 11.937)",
						fill: "#dad9ef",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_729",
						"data-name": "Rectangle 729",
						width: 9.284,
						height: 7.958,
						transform: "translate(2.653 3.979)",
						fill: "#d9daee",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_375",
						"data-name": "Line 375",
						y1: 3.979,
						transform: "translate(7.295)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2176",
						"data-name": "Path 2176",
						d: "M0,0H11.937V23.873H0Z",
						transform: "translate(18.568 6.632)",
						fill: "#d9daee",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_376",
						"data-name": "Line 376",
						x2: 6.632,
						transform: "translate(21.221 9.284)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_377",
						"data-name": "Line 377",
						x2: 6.632,
						transform: "translate(21.221 11.937)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_378",
						"data-name": "Line 378",
						x2: 6.632,
						transform: "translate(21.221 14.589)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_379",
						"data-name": "Line 379",
						x2: 6.632,
						transform: "translate(21.221 17.242)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_380",
						"data-name": "Line 380",
						x2: 6.632,
						transform: "translate(21.221 19.895)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_381",
						"data-name": "Line 381",
						x2: 6.632,
						transform: "translate(21.221 22.547)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_382",
						"data-name": "Line 382",
						x2: 6.632,
						transform: "translate(21.221 25.2)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_383",
						"data-name": "Line 383",
						x2: 9.284,
						transform: "translate(2.653 15.916)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_384",
						"data-name": "Line 384",
						x2: 9.284,
						transform: "translate(2.653 19.895)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_385",
						"data-name": "Line 385",
						x2: 9.284,
						transform: "translate(2.653 23.873)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_386",
						"data-name": "Line 386",
						x2: 3.979,
						transform: "translate(5.305 6.632)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("line", {
						id: "Line_387",
						"data-name": "Line 387",
						x2: 3.979,
						transform: "translate(5.305 9.284)",
						fill: "none",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_731",
						"data-name": "Rectangle 731",
						width: 2.653,
						height: 2.653,
						transform: "translate(6.632 27.852)",
						fill: "rgba(0,0,0,0)",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_732",
						"data-name": "Rectangle 732",
						width: 2.653,
						height: 2.653,
						transform: "translate(23.21 27.852)",
						fill: "rgba(0,0,0,0)",
						stroke: "#7284fa",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1
					})
				]
			}), /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_733",
				"data-name": "Rectangle 733",
				width: 32,
				height: 32,
				fill: "none"
			})]
		})]
	})
});
export default SvgBuildings;
